import React, { useEffect, useState } from 'react';

import { RadioGroup } from '../../../../../../Styles';

const Reasons = ({ value = '', error = '', disabled = false, onChange = null, onError = null }) => {
	const [inputValue, setInputValue] = useState(value);

	const validate = () => {
		let error = null;

		if (inputValue === '') {
			error = 'Please select an option';
		}

		onError(error);
		return !error;
	};

	useEffect(() => {
		validate();
		onChange(inputValue);
	}, [inputValue]);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<RadioGroup
			fullWidth
			name='reasons'
			value={inputValue}
			options={[
				{ name: 'Reason 1', value: 'REASON_1' },
				{ name: 'Reason 2', value: 'REASON_2' },
				{ name: 'Reason 3', value: 'REASON_3' },
				{ name: 'Others', value: 'OTHER' },
			]}

			onClick={(e) => {
				setInputValue(e.target.value);
			}}
			error={error}
		/>
	);
};

export default Reasons;
